import getRebill from './actions/getRebill';
import getRebillsGroups from './actions/getRebillsGroups';
import rebillsList from './actions/rebillsList';
import getRebills from './getters/getRebills';
import uploadRebills from './mutations/uploadRebills';

const actions = {
    rebillsList,
    getRebill,
    getRebillsGroups
};

const mutations = {
    uploadRebills
};

const getters = {
    getRebills
};

export default { actions, mutations, getters };
